import {Component, output, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-menu-dialog",
    templateUrl: "./menu-dialog.component.html",
    styleUrls: ["./menu-dialog.component.scss"],
})
export class MenuDialogComponent {
    readonly close = output<void>()
}
